import type { BridgeMessage } from '@healthhub/message-channel';
import { useGetBridgeMessage } from '@healthhub/react-ui';
import { useCallback, useEffect, useRef } from 'react';

import { MESSAGE_ACTIONS_KEYS } from '@shared/utils/bridge';

export const useMobileStoreSubscription = () => {
  const { messages: mobileStoreGetResult, consumeBridgeMessage } = useGetBridgeMessage(
    MESSAGE_ACTIONS_KEYS.mobileStoreGetResult
  );

  const mobileStoreGetResultRef = useRef(mobileStoreGetResult);
  const messageSubscribersRef = useRef(new Set<(messages: BridgeMessage[]) => void>());

  useEffect(() => {
    mobileStoreGetResultRef.current = mobileStoreGetResult;
    messageSubscribersRef.current.forEach((listener) => {
      listener(mobileStoreGetResult);
    });
  }, [mobileStoreGetResult]);

  const subscribeMessages = useCallback((listener: (messages: BridgeMessage[]) => void) => {
    messageSubscribersRef.current.add(listener);
    listener(mobileStoreGetResultRef.current ?? []);
    return () => {
      messageSubscribersRef.current.delete(listener);
    };
  }, []);

  return { consumeBridgeMessage, subscribeMessages };
};
